module.exports = __webpack_public_path__ + "img/ic_oui_black.41856b4e.svg";